(function () {

    'use strict';

    angular.module('vholsPostCodeAnywhere', []);

})();
(function () {

    'use strict';

    /***
     * Service that calls the postcodeanywhere captureplus end-point with a search terms, and returns a promise containing the results.
     * Potential errors which might be returned from the end-point can be found at:
     * http://www.postcodeanywhere.co.uk/Support/WebService/CapturePlus/Interactive/Find/2.1/
     */
    angular.module('vholsPostCodeAnywhere')
        .service('postCodeAnywhereService', function ($http) {

            var KEY = 'AX24-HZ15-CG93-ZP91';
            var PATTERN = /^(GIR|[A-Za-z]\d[A-Za-z\d]??|[A-Za-z]{2}\d[A-Za-z\d]??)[ ]??(\d[A-Za-z]{2})$/;

            /***
             * The main search function
             * @param {String} searchTerm - the post UK postcode.
             */
            var postCodeLookup = function (searchTerm) {

                if (searchTerm) {
                    searchTerm = searchTerm.toUpperCase();
                }

                // postcodeanywhere performs postcode validation and returns the following error if invalid: 1002
                // with this in mind, we still need to prevent unecessary hits on the service.
                if (!PATTERN.exec(searchTerm)) {
                    throw new Error('searchTerm provided is not a valid post code.');
                } else {
                    return $http.jsonp('//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws', {
                        method: 'GET',
                        params: {
                            Key: KEY,
                            SearchTerm: searchTerm,
                            LastId: '',
                            SearchFor: 'PostalCodes',
                            callback: 'JSON_CALLBACK'
                        }
                    });
                }
            };

            /***
             * uses the unique id returned by postcodeanywhere to retrieve the formatted address object
             * @param {String} id - the address' unique id
             */
            var fetchAddressById = function (id) {
                if (!id) {
                    throw new Error('An address id must be specified');
                }
                return $http.jsonp('//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws', {
                    method: 'GET',
                    params: {
                        Key: KEY,
                        Id: id,
                        callback: 'JSON_CALLBACK'
                    }
                });
            };

            return {
                postCodeLookup: postCodeLookup,
                fetchAddressById: fetchAddressById
            }
        });
})();
